<!-- checkout.component.html -->
<h2>Checkout</h2>
<form (ngSubmit)="onSubmit()">
  <label>
    Dirección de envío:
    <input [(ngModel)]="shippingAddress"
           name="shippingAddress"
           required>
  </label>

  <br /><br />

  <label>
    Método de pago:
    <select [(ngModel)]="paymentMethod"
            name="paymentMethod">
      <option value="credit_card">Tarjeta de crédito</option>
      <option value="paypal">PayPal</option>
    </select>
  </label>

  <br /><br />

  <button type="submit">Pagar</button>
</form>
